"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_CONTRACT_LINE_ITEM = exports.CREATE_CONTRACT_LINE_ITEM = void 0;
exports.CREATE_CONTRACT_LINE_ITEM = `
	mutation selectBenefit($data: BenefitSelection, $membershipBody: String){
		selectBenefit(data: $data, membershipBody: $membershipBody)
	}
`;
exports.DELETE_CONTRACT_LINE_ITEM = `
	mutation unselectBenefit($ids: [String], $subscriptionData: SubscriptionItems){
		unselectBenefit(ids: $ids, subscriptionData: $subscriptionData) 
	}
`;
//# sourceMappingURL=contract-line-item-queries.js.map